<template>
  <div class="login-page">
    <div class="login-shell">
      <section class="login-overview">
        <div class="brand-mark">
          <img :src="$brand.logoUrl" alt="" class="brand-logo">
          <span>{{ $brand.companyName }}</span>
        </div>
        <div class="overview-copy">
          <p class="eyebrow">Enterprise HRM Platform</p>
          <h1>{{ $brand.loginTitle }}</h1>
          <p class="overview-desc">面向组织、人事、考勤、薪酬与文档协同的一体化管理入口，支撑企业日常运营和权限化办公。</p>
        </div>
        <div class="capability-grid">
          <div class="capability-item">
            <strong>人事管理</strong>
            <span>员工档案、部门组织、角色权限</span>
          </div>
          <div class="capability-item">
            <strong>考勤协同</strong>
            <span>考勤记录、请假流程、绩效跟踪</span>
          </div>
          <div class="capability-item">
            <strong>薪酬社保</strong>
            <span>薪资核算、社保管理、城市基数</span>
          </div>
          <div class="capability-item">
            <strong>文档资产</strong>
            <span>资料归档、文件预览、下载管理</span>
          </div>
        </div>
      </section>
      <section class="login-card">
        <div class="login-title">
          <img :src="$brand.logoUrl" alt="" class="login-logo">
          <h2>账号登录</h2>
          <p>{{ $brand.systemName }} · 统一身份入口</p>
        </div>
        <el-form :rules="rules" :model="staff" ref="loginForm" class="login-form">
          <el-form-item prop="code">
            <el-input
              size="medium"
              placeholder="请输入账号"
              prefix-icon="el-icon-user"
              v-model.trim="staff.code"
            />
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              size="medium"
              placeholder="请输入密码"
              prefix-icon="el-icon-lock"
              show-password
              v-model.trim="staff.password"
              @keyup.enter.native="handleLogin"
            />
          </el-form-item>
          <el-button type="primary" class="login-button" @click="handleLogin">登 录</el-button>
        </el-form>
      </section>
    </div>
  </div>
</template>
<script>
import { login } from '../../api/login'

export default {
  name: 'Login',
  data () {
    return {
      staff: {},
      // 效验规则
      rules: {
        code: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          { min: 3, max: 10, message: '长度在3到10个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 3, max: 10, message: '长度在3到10个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleLogin () {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          login(this.staff).then(
            response => {
              if (response.code === 200) {
                this.$store.commit('staff/SET_STAFF', response.data) // 存储用户信息
                this.$store.commit('token/SET_TOKEN', response.token) // 存储token
                this.$message.success('登录成功！')
                this.$router.push({
                  path: '/home'
                })
              } else {
                this.$message.error(response.message)
              }
            }
          )
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style scoped>
.login-page {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 48px;
  overflow: hidden;
  background:
    linear-gradient(115deg, rgba(246, 248, 252, 0.96) 0%, rgba(239, 244, 250, 0.92) 46%, rgba(229, 237, 247, 0.88) 100%),
    url("../../assets/bg2.jpg") center/cover no-repeat;
}

.login-page::before,
.login-page::after {
  position: absolute;
  content: "";
  pointer-events: none;
}

.login-page::before {
  top: 0;
  left: 0;
  width: 58%;
  height: 100%;
  background: linear-gradient(135deg, rgba(18, 42, 72, 0.96), rgba(42, 74, 115, 0.86));
  clip-path: polygon(0 0, 84% 0, 100% 100%, 0 100%);
}

.login-page::after {
  inset: 24px;
  border: 1px solid rgba(18, 42, 72, 0.08);
}

.login-shell {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 420px;
  gap: 56px;
  align-items: center;
  width: min(1120px, 100%);
}

.login-overview {
  color: #ffffff;
}

.brand-mark {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  padding: 9px 14px;
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.92);
  font-size: 15px;
  font-weight: 500;
}

.brand-logo {
  width: 28px;
  height: 28px;
  margin-right: 10px;
  object-fit: contain;
}

.overview-copy {
  max-width: 620px;
  margin-top: 54px;
}

.eyebrow {
  margin: 0 0 14px;
  color: rgba(255, 255, 255, 0.68);
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0;
  text-transform: uppercase;
}

.overview-copy h1 {
  margin: 0;
  color: #ffffff;
  font-size: 42px;
  font-weight: 600;
  line-height: 1.22;
  letter-spacing: 0;
}

.overview-desc {
  max-width: 560px;
  margin: 22px 0 0;
  color: rgba(255, 255, 255, 0.78);
  font-size: 16px;
  line-height: 1.8;
}

.capability-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  max-width: 640px;
  margin-top: 54px;
}

.capability-item {
  min-height: 92px;
  padding: 18px 20px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(6px);
}

.capability-item strong {
  display: block;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
}

.capability-item span {
  display: block;
  margin-top: 9px;
  color: rgba(255, 255, 255, 0.68);
  font-size: 13px;
  line-height: 1.55;
}

.login-card {
  width: 100%;
  padding: 42px 40px 38px;
  border: 1px solid rgba(30, 46, 78, 0.08);
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 24px 58px rgba(28, 45, 72, 0.16);
}

.login-title {
  margin-bottom: 30px;
}

.login-logo {
  width: 44px;
  height: 44px;
  margin-bottom: 18px;
  object-fit: contain;
}

.login-title h2 {
  margin: 0;
  color: #1c2636;
  font-size: 26px;
  font-weight: 600;
  letter-spacing: 0;
}

.login-title p {
  margin: 10px 0 0;
  color: #687385;
  font-size: 14px;
}

.login-form /deep/ .el-input__inner {
  height: 48px;
  border-color: #d9e0ea;
  border-radius: 14px;
  color: #1f2937;
}

.login-form /deep/ .el-input__inner:focus {
  border-color: #426d9f;
}

.login-form /deep/ .el-form-item {
  margin-bottom: 22px;
}

.login-button {
  width: 100%;
  height: 48px;
  margin-top: 8px;
  border: none;
  border-radius: 14px;
  background: linear-gradient(135deg, #1d3557, #426d9f);
  box-shadow: 0 14px 26px rgba(29, 53, 87, 0.18);
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 4px;
}

.login-button:hover,
.login-button:focus {
  background: linear-gradient(135deg, #27456f, #4a79ad);
}

@media (max-width: 980px) {
  .login-page {
    min-height: 100vh;
    padding: 32px 20px;
  }

  .login-page::before {
    width: 100%;
    clip-path: none;
  }

  .login-page::after {
    inset: 16px;
  }

  .login-shell {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .overview-copy {
    margin-top: 28px;
  }

  .overview-copy h1 {
    font-size: 32px;
  }

  .overview-desc {
    font-size: 15px;
  }

  .capability-grid {
    margin-top: 28px;
  }
}

@media (max-width: 640px) {
  .login-page {
    align-items: flex-start;
    justify-content: center;
    padding: 22px 16px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .brand-mark {
    font-size: 14px;
  }

  .overview-copy {
    margin-top: 24px;
  }

  .overview-copy h1 {
    font-size: 26px;
  }

  .overview-desc {
    margin-top: 16px;
    line-height: 1.65;
  }

  .capability-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .capability-item {
    min-height: auto;
    padding: 14px 16px;
  }

  .login-card {
    width: 100%;
    padding: 30px 22px 26px;
  }

  .login-title {
    margin-bottom: 24px;
  }

  .login-title h2 {
    font-size: 24px;
  }
}
</style>
